import { $messageCentreStore } from '@lib/store';
import { DateUtils } from '@shared/utils';
import type { ThreadsMessagesResponse } from '@shared/api/rest/messages';
import { MessageWrapper } from './messageWrapper';
import { Button, ColorsEnum, Icon, MessageFile, Text } from '@shared/widgets';
import ShareIcon from '@assets/icons/share.svg';

export interface IMessageProps {
  message: ThreadsMessagesResponse;
  onClickReply: () => void;
}

export const Message = (props: IMessageProps) => {
  const downloadHandler = (fileId: string, messageId: string) => {
    $messageCentreStore.events.downloadAttachment({ fileId, messageId });
  };

  return (
    <MessageWrapper parentClName='pl-4'>
      <div className='flex-auto min-w-[0]'>
        <Text className='mb-2' size='sm' color={ColorsEnum.Gray}>
          {DateUtils.formatDate(props.message.createdOn, { withTime: true })}
        </Text>
        <div className='mb-2'>
          <Text size='sm'>{props.message.body}</Text>
        </div>
        {props.message.attachments?.map((attachment) => (
          <MessageFile key={attachment.id} attachment={attachment} download={() => downloadHandler(attachment.id, props.message.messageId)} />
        ))}
      </div>
      <div className='flex-none flex flex-col items-end ml-5'>
        <div className='mt-auto'>
          <Button className='w-6 h-6' color='icon' onClick={props.onClickReply}>
            <Icon icon={<ShareIcon />} />
          </Button>
        </div>
      </div>
    </MessageWrapper>
  );
};
